import { Component, Input } from "@angular/core";

import { Status } from "@lantern/app/models/status";

@Component({
  selector: "ta-spinner-icon",
  templateUrl: "spinner-icon.template.html"
})
export class SpinnerIconComponent {
  @Input()
  status: Status;
}
